import { PayPalButtons } from "@paypal/react-paypal-js";
import { connect } from "react-redux";
import { push } from "connected-react-router";

// Utils
import { post } from "library/endpoints";

/**
 * PaypalGiftcardPayment
 * @param {*} props 
 * @returns 
 */
const PaypalGiftcardPayment = (props) => {
  const createOrder = async () => {
    try {
      const response = await post(`/frontend/payment/giftcard/create-paypal-order/${props.basket._id}`);
      return response.data.id
    } catch (error) {
      console.log(props.basket._id)
      console.log(error)
    }
  }

  const onApprove = async (data) => {
    try {
      await post(`/frontend/payment/giftcard/capture-paypal-payment/${props.basket._id}`, data);
      props.push(`/giftcard/callback/${props.basket._id}/paypal`)
    } catch (error) {
      console.log(error)
      // props.push(`/giftcard/callback`)
    }
  }

  return (
    <PayPalButtons
      createOrder={createOrder}
      onApprove={onApprove}
      style={{
        layout: 'horizontal',
      }}
    /> 
  )
}

const stateToProps = state => ({
  
})

const dispatchToProps = {
  push
}

export default connect(stateToProps, dispatchToProps)(PaypalGiftcardPayment);